import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchProducts } from '../slices/productSlice';
import { fetchEmployees } from '../slices/employeeSlice';
import { fetchWarehouses } from '../slices/warehouseSlice';

/**
 * Custom hook that automatically refreshes data when the store changes
 * @param {string} dataType - Type of data to refresh ('products', 'employees', 'warehouses', or 'all')
 */
export const useStoreDataRefresh = (dataType = 'all') => {
  const dispatch = useDispatch();
  const { selectedStore, lastStoreChange } = useSelector((state) => state.store);
  const lastStoreChangeRef = useRef(lastStoreChange);

  useEffect(() => {
    // Only refresh if we have a selected store and the store has actually changed
    if (selectedStore && lastStoreChange && lastStoreChange !== lastStoreChangeRef.current) {
      lastStoreChangeRef.current = lastStoreChange;
      
      // Small delay to ensure the store context is updated
      const timeoutId = setTimeout(() => {
        if (dataType === 'all' || dataType === 'products') {
          dispatch(fetchProducts());
        }
        if (dataType === 'all' || dataType === 'employees') {
          dispatch(fetchEmployees());
        }
        if (dataType === 'all' || dataType === 'warehouses') {
          dispatch(fetchWarehouses());
        }
      }, 100);

      return () => clearTimeout(timeoutId);
    }
  }, [dispatch, selectedStore, lastStoreChange, dataType]);

  return { selectedStore, lastStoreChange };
}; 